export default __webpack_public_path__ + "static/media/down-icon-black.a85c928d.svg";